import React from 'react';
import { ContentArea } from './components/base/container/container';
import VideoModal from './components/modals/videoModal/videoModal';
import About from './components/sections/about/about';
import Photos from './components/sections/photos/photos';
import Events from './components/sections/events/events';
import Contact from './components/sections/contact/contact';
import title from './title.svg';
import './App.css';

const Landing = () => {
  return(
    <React.Fragment>
      <header>
        <div className="header-column left">
          <img className="title" src={title} alt="porno_und:_piano" />
        </div>
        <div className="header-column right">
          <VideoModal />
        </div>
      </header>
      <ContentArea>
        <section className="current-section">
          <h1 className="description">
            PORNO UND PIANO: Erotic Literature and Music performance
          </h1>
          <br />
          <span className="next-event">
            Next event: "Fe/male pleasures"
              | March 8, 2019, 19h (doors open)
              | @&nbsp;
                <a
                  href="https://tatwerk-berlin.de/de/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  TATWERK Performative Forschung
                </a>
          </span>
          <br />
          <ul>
            <li>Hasenheide 9</li>
            <li>Gewerbehof - 2. Hinterhof, Aufgang 1, 3. OG</li>
            <li>10967 Berlin Kreuzberg</li>
            <li>U7 &amp; U8 Hermannplatz</li>
          </ul>
          <br />
          <img
            src="http://pornoundpiano.de/assets/media/img/thumbnails/next_event_thumb.png"
            alt="next_event_thumbnails"
          />
          <div className="next-event__details">
            <p>
              On the International Women's Day "Fe/male Flavours"
              is going to celebrate the plurality of feminity.
              PORNO UND PIANO will be in the thick of it:
              This time we will guide you from a famous Ménage à Trois
              to the evolution of the vibrator,
              with a detour into the hidden territory of the female sex organ.
            </p>
            <ul>
              <li>19h-: Doors open, sexy snacks and exhibition opening „The Cylce Diaries“ (Mara Klein)</li>
              <li>Walk-in installation „WHAT’S LEFT OF / die unsichtbare Stadt“</li>
              <li>20h: „Who is she“ by Amelia Emma Forrest &amp; Judy LaDivina</li>
              <li>21h: PORNO UND PIANO</li>
              <li>Until midnight: Drinks, sexy snacks and pregame</li>
            </ul>
            <p>
              Be curious about a highly creative and stimulating program
              with fine arts, performance and culinary
              - femininity for listening, seeing and tasting.
            </p>
            <p>
              Entry fee: 5-20 Euro Sliding Scale.
            </p>
            <p>
              Reserve a ticket at info(at)tatwerk-berlin(dot)de.
            </p>
          </div>
        </section>
      </ContentArea>
    </React.Fragment>
  );
}

export const Home = () => {
  return(
    <React.Fragment>
      <Landing />
      <About />
      <Photos />
      <Events />
      <Contact />
    </React.Fragment>
  );
}

export const Imprint = () => <ImprintContent />;

export const Press = () => <PressContent />;

const ImprintContent = () => {
  return(
  <ContentArea>
    <section className="imprint-section">
      <h2>Imprint</h2>
      <p>Verantwortlich im Sinne des Presserechts:</p>
      <p>Ruben Giannotti <br /> Kiautschoustr. 19 <br /> 13353 berlin</p>
      <p>
        Fotos:&nbsp;
          <a href='https://www.franksperling.net/' target='_blank' rel="noopener noreferrer">Frank Sperling</a>,&nbsp;
          <a href='http://sarahlikesprettygirls.tumblr.com/' target='_blank' rel="noopener noreferrer">Sarah Bleszynski</a>
        <br />
        Webdesign: <a href='http://www.rubengiannotti.com' target='_blank' rel="noopener noreferrer">Ruben Giannotti</a>
      </p>
      <p>
        Alle Rechte vorbehalten.
        Die durch den Autor erstellten Inhalte auf dieser Seite unterliegen dem Urheberrecht und anderen Gesetzen zum Schutz des geistigen Eigentums.
        Die Weitergabe, Ver&auml;nderung, gewerbliche Nutzung oder Verwendung auf anderen Internetseiten ist untersagt.
      </p>
      <p>
        Soweit die Inhalte auf dieser Seite nicht vom Autor erstellt wurden,
        werden die Urheberrechte Dritter beachtet und die betreffenden Inhalte als solche gekennzeichnet.
        Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
        bittet der Autor um einen entsprechenden Hinweis.
        Bei Bekanntwerden von Rechtsverletzungen werden derartige Inhalte unverzüglich entfernt.
      </p>
      <br /><br />
      <h3>Haftungsausschluss</h3>
      <h4>Inhalt</h4>
      <p> 
        Der Autor übernimmt, obgleich die Inhalte dieser Seite mit größter Sorgfalt ausgewählt wurden, keinerlei Gewähr für dessen Aktualität, Richtigkeit oder Vollständigkeit.
      </p>
      <p>
        Gemäß §7 I TMG ist der Autor für eigene Inhalte dieser Seite nach den allgemeinen Gesetzen verantwortlich.
        Es sind jedoch Haftungsansprüche gegen den Autor, die sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen verursacht wurden, grundsätzlich ausgeschlossen.
        Alle Angebote sind freibleibend und unverbindlich.
      </p>
        Darüberhinaus behält der Autor sich vor, die Angebote dieser Seite ohne gesonderte Ankündigung zu verändern, zu ergänzen oder zu löschen.
      <p>
        Auf übermittelte oder gespeicherte fremde Inhalte hat der Autor keinen Einfluss und übernimmt dafür keinerlei Verantwortung.
        Sollten durch die fremden Inhalte Rechte oder gesetzliche Vorschriften verletzt werden, wird der Autor die betreffenden Inhalte bei Bekanntwerden der Rechtsverletzung unverzüglich entfernen.
      </p>
      <h4>Links</h4>
      <p>
        Das Angebot dieser Seite beinhaltet Verweise auf fremde Internetseiten (&#187;Hyperlinks&#171;).
        Sofern diese nicht im Verantwortungs- oder Einflussbereich des Autors liegen, kann für die Inhalte der verlinkten Seiten keine Gewähr übernommen werden.
      </p>
      <p>
        Der Autor erklärt hiermit, dass zum Zeitpunkt der Linksetzung auf den verlinkten Seiten keine rechtswidirgen Inhalte erkennbar waren.
        Eine fortwährende inhaltliche Kontrolle der verlinkten Seiten ist indessen ohne konkrete Anhaltspunkte nicht zumutbar.
        Daher distanziert sich der Autor ausdrücklich von den fremden Seiteninhalten.
        Sollten durch diese Inhalte Rechte oder gesetzliche Vorschriften verletzt werden, wird der Autor derartige Links unverzüglich entfernen, sobald ihm die Rechtsverletzung bekannt geworden ist.
      </p>
      <h4>Datenschutz</h4>
      <p>
        Es ist im Rahmen des Angebots dieser Seite möglich, personenbezogene Daten einzugeben (z.B. für den Newsletter), wobei die Nutzung dieser Seite auch ohne die Preisgabe personenbezogener Daten möglich ist.
        Die Angabe derartiger Daten erfolgt ausdrücklich auf freiwilliger Basis und selbige werden nicht an Dritte weitergegeben.
        Es sei hierbei darauf hingewisen, dass die Datenübertragung im Internet (z.B. per E-Mail) Sicherheitslücken aufweisen kann.
        Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte kann daher nicht gewähleistet werden.
      </p>
      <p>
        Der Versand der Newsletter erfolgt mittels des Versanddienstleisters &#187;MailChimp&#171;, einer Newsletterversandplattform des US-Anbieters Rocket Science Group, LLC, 675 Ponce De Leon Ave NE #5000, Atlanta, GA 30308, USA.
        Die Datenschutzbestimmungen des Versanddienstleisters können Sie <a href="https://mailchimp.com/legal/privacy/">hier</a> einsehen.
        The Rocket Science Group LLC d/b/a MailChimp ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das
        <a href="https://www.privacyshield.gov/participant?id=a2zt0000000TO6hAAG&status=Active" target="_blank" rel="noopener noreferrer">
          europäisches Datenschutzniveau
        </a>
        einzuhalten.
        Der Versanddienstleister wird auf Grundlage unserer berechtigten Interessen gem. Art. 6 Abs. 1 lit. f. DSGVO und eines Auftragsverarbeitungsvertrages gem. Art. 28 Abs. 3 S. 1 DSGVO eingesetzt.
      </p>
      <p>
        Der Versanddienstleister kann die Daten der Empfänger in pseudonymer Form,
        d.h. ohne Zuordnung zu einem Nutzer, zur Optimierung oder Verbesserung der eigenen Services nutzen, z.B. zur technischen Optimierung des Versandes und der Darstellung der Newsletter oder für statistische Zwecke verwenden.
        Der Versanddienstleister nutzt die Daten unserer Newsletterempfänger jedoch nicht, um diese selbst anzuschreiben oder um die Daten an Dritte weiterzugeben.
      </p>
      <p>
        Die Nutzung der im Rahmen des Impressums oder vergleichbarer Angaben veröffentlichten Kontaktdaten wie Postanschriften, Telefon- und Faxnummern sowie E-Mail-Adressen durch Dritte zur Übersendung von nicht ausdrücklich angefohrderten Informationen ist untersagt.
        Rechtliche Schritte gegen die Versender von sogenannten Spam-Mails bei Verstößen gegen dieses Verbot sind vorbehalten.
      </p>
    </section>
  </ContentArea>
  );
}

//const press1 = './press_photo-1.tif';
const pressPhotoA = 'http://pornoundpiano.de/assets/media/img/press/press_photo-2.jpg';
const pressPhotoB = 'http://pornoundpiano.de/assets/media/img/press/press_photo-3.jpg';

const PressContent = () => {
  return(
    <ContentArea>
      <section className="press-section">
        <h2>Press distribution content</h2>
        <h3>Fe/male Flavours am 8. März im TATWERK</h3>
        <h4>Ein Abend zu Körpern, Sex und Selbstbestimmung</h4>
        <p>
        Der 8. März ist in diesem Jahr erstmals offizieller Feiertag in Berlin. Feiern wir anlässlich des Internationalen Frauentags eine solidarische Weiblichkeit: Eine Weiblichkeit, die über das allgemein anerkannte „biologisch Weibliche“ hinausgeht und jene einschließt, die sich selbst als weiblich definieren. 
        Die Besucher*innen von Fe/male Flavours erwartet am 8. März 2019 im TATWERK | Performative Forschung ab 19 Uhr ein kreatives Programm aus Kunst, Performance und Kulinarischem, das alle Sinne stimuliert. Ein Abend, der sich selbstbestimmten Körpern, sinnlichen Freuden und individueller Sexualität verschreibt – Weiblichkeit zum Hören, Sehen und Schmecken. 
        </p>
        <p>
        Während Hobbyköchin und Brasilien-Enthusiastin Carolin Dandaras für die Gäste eine feministische Version des brasilianischen Käsebrots bäckt, setzt Mara Kleins photographische Serie „The Cycle Diaries“ den weiblichen Zyklus künstlerisch in Szene. 
        Die Kunstinstallation „WHAT’S LEFT OF / die unsichtbare Stadt“ von Aurora Kellermann lädt dazu ein, Momentaufnahmen des Lebens Berliner Sexarbeiter*innen zu erleben  
        In literarischen Streifzügen entführt die erotische Lese- und Musikreihe PORNO UND PIANO von der berühmten Ménage à Trois zwischen Anais Nin, Henry Miller und seiner Frau June, entlang der verborgenen Teile des weiblichen Lustorgans bis zur Evolutionsgeschichte des Vibrators. 
        Drag Künstler*in Judy LaDivina und Performer*in Amelia Emma Forrest präsentieren zum krönenden Abschluss eine Erzählung von Mitgefühl, Dringlichkeit und Anerkennung.
        </p>
        <h4>Programm</h4>
        <p>
        Ab 19 Uhr: Doors Open, Sexy Snacks und Ausstellungseröffnung „The Cylce Diaries“ (Mara Klein und N.N.) 
        Begehbare Installation „WHAT’S LEFT OF / die unsichtbare Stadt“
        </p>
        <ul>
          <li>Ab 19 Uhr: Doors Open, Sexy Snacks und Ausstellungseröffnung „The Cylce Diaries“ (Mara Klein und N.N.)</li>
          <li>Begehbare Installation „WHAT’S LEFT OF / die unsichtbare Stadt“</li>
          <li>20 Uhr: „Who is she“ von Amelia Emma Forrest &amp; Judy LaDivina</li>
          <li>21 Uhr: PORNO UND PIANO</li>
          <li>Bis Mitternacht: Drinks, sexy Snacks und Vorglühen</li>
        </ul>
        <br />
        <h4>Ort</h4>
        <span>TATWERK | Performative Forschung</span>
        <ul>
          <li>Hasenheide 9</li>
          <li>Gewerbehof - 2. Hinterhof, Aufgang 1, 3. OG</li>
          <li>10967 Berlin Kreuzberg</li>
          <li>U7 &amp; U8 Hermannplatz</li>
          <li>Eintritt &amp; Reservierung: 5-20 Euro Sliding Scale</li>
          <li>Begrenzte Platzzahl, Reservierung unter info@tatwerk-berlin.de</li>
        </ul>
        <br />
        <h4>Hintergrundinformationen</h4>
        <p>
        Sexy Snacks von Carolin Dandara
        Carolin Dandaras sexy Snacks für Frauen in Brasilien, wo aktuell der frauenfeindliche Bolsonaro amtiert. Hobbyköchin, Capoeirista und Brasilien-Enthusiastin Carolin backt für euch eine feministische Version des brasilianischen Käsebrots „pao de qeijo“ 
        </p>
        <p>
        The Cycle Diaries von Mara Klein (Photoserie)
        Die photographische Serie The Cycle Diaries ist eine wissenschaftlich-poetische Erkundung des weiblichen Zyklus. Aus dem Medizinlabor ins Fotostudio: Mara Klein hat die Flora der Vulva mikroskopisch untersucht und daraus faszinierende Photoarbeiten geschaffen, die in ihrer Zartheit an japanische Kirschblüten erinnern. 
        </p>
        <p>
        What’s left of / Die unsichtbare Stadt von Aurora Kellermann (Installation zu Sexarbeit)
        In einem Raum finden 250 Orte der Sexarbeit zusammen: Entstanden auf einer Tour quer durch Berlin, vergegenwärtigen Momentaufnahmen Bordelle, Massage Salons, Sex Kinos, Erotikclubs und Straßenstriche. Eine abstrakte Kartierung, ein unsichtbarer Stadtplan Berlins entsteht. Aurora Kellermann interviewte Berliner Sexarbeiter*innen und hat die Gespräche in Zusammenarbeit mit Jasmine Guffond zu einer facettenreiche, Komposition zusammengefügt. 
        Who is she von Amelia Emma Forrest & Judy LaDivina (Performance)
        Drag Künstler*in Judy LaDivina und Performer*in Amelia Emma Forrest präsentieren eine Erzählung von Mitgefühl, Dringlichkeit und Anerkennung. Eine eindrucksvolle Performance über weibliches Sehen und Gesehen-werden in einem von männlicher Dominanz geprägten Alltag.
        Music von Ampfer, Innocent Heretic, Marie Davidson & Shy
        </p>
        <ul>
          <li>Visuals von Charis Boon Films</li>
          <li>Languages: English, Hebrew & French</li>
        </ul>
        <br />
        <h4>Porno & Piano</h4>
        <p>
        Hinter dem genüsslich klingenden Titel verbirgt sich eine einmalige Kombination aus Text und Musik, Diskurs und Sinnlichkeit, Rollenspiel und Gesellschaftsanalyse. Die musikalische Lesereihe Porno und Piano verwebt Pornodialoge mit theoretischen Texten und Werken moderner Dichter- und Denker*innen zu literarischen Collagen – gerahmt von und gewürzt mit neuer, experimenteller Livemusik. Gelesen werden Auszüge aus Klassikern der Weltliteratur und lyrische Werke vergangener Epochen ebenso wie anonyme Alltagsnotizen und Perlen der Popkultur. 
        </p>
        <h4>Über das TATWERK</h4>
        <p>
        Das TATWERK | Performative Forschung ist eine Produktionsstätte und Studio der Performativen Künste, Anlaufpunkt für Künstler*innen, die den Körper als Materie und die Forschung als Instrument ihrer Arbeit gewählt haben. 
        </p>
        <span>Weitere Infos:</span>
        <ul>
          <li>www.tatwerk-berlin.de</li>
          <li>www.pornoundpiano.de</li>
        </ul>
        <br />
        <h4>Pressefotos</h4>
        <a className="img-link" href={pressPhotoA} download>
          <img src={pressPhotoA} alt="press_photo-2" />
        </a>
        <a className="img-link" href={pressPhotoB} download>
          <img src={pressPhotoB} alt="press_photo-3" />
        </a>
        <p>
          Die gesamte Sammlung an Fotos und Grafiken steht&nbsp;
          <a
            href="https://app.box.com/s/c6cu8sglip1xb6gbxo78fya1wvhn3b3h"
            target="_blank"
            rel="noopener noreferrer"
          >
            hier
          </a>
          &nbsp;zur Verfügung.
        </p>
      </section>
    </ContentArea>
  );
}
